import React, { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SectionTabs = ({ items }) => {
  const location = useLocation();
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'instant' });
    }
  }, [location.pathname]);

  return (
    <div className="flex items-center justify-start sm:justify-center gap-1.5 mb-4 mt-2 overflow-x-auto scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0">
      {items.map(({ label, to, icon: Icon }) => {
        const isActive = location.pathname === to;
        return (
          <Link
            key={to}
            to={to}
            ref={isActive ? activeRef : null}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors shrink-0 ${
              isActive
                ? 'bg-sky-500/20 text-sky-400 border border-sky-500/30'
                : 'bg-white/[0.04] text-slate-400 border border-white/[0.08] hover:bg-white/[0.08]'
            }`}
          >
            {Icon && <Icon className="w-3.5 h-3.5" />}
            {label}
          </Link>
        );
      })}
    </div>
  );
};

export default SectionTabs;
